// extracted by mini-css-extract-plugin
export default {"footer":"AddUserModal_footer__p58oh","body":"AddUserModal_body__pCwCD","services":"AddUserModal_services__tQfcn","allowed":"AddUserModal_allowed__rlQso"};